import React from "react";
import styled from "@emotion/styled";
import { BRACELET_COLORS, BRACELET_NAMES } from "fixtures/play-colors";

const Container = styled.div`
  width: 100%;
  margin-bottom: 15px;
  padding: 16px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  background-color: #282a2b;
  border-radius: 5px;
  border-right: solid 12px ${props => props.teamColor};

  h4 {
    margin: 0;
    font-family: ${props => props.theme.fonts.subheading};
    text-transform: capitalize;
    font-size: 20px;
  }

  h3 {
    margin: 0;
    font-family: ${props => props.theme.fonts.subheading};
    font-size: 16px;
    font-weight: normal;
    text-transform: capitalize;
  }
`;
const RankAndPlayer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

const Player = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 10px;
  margin-right: 28px;
`;

const Rank = styled.h2`
  margin: 0;
  margin-right: 10px;
  font-size: 28px;
`;

const Point = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  svg {
    margin-right: 4px;
  }
`;

const Medal = styled.div`
  font-size: 28px;
`;

export default function LeaderboardRankCard(props) {
  function MedalRank(rank) {
    if (rank == 1) {
      return <Medal>🥇</Medal>;
    } else if (rank == 2) {
      return <Medal>🥈</Medal>;
    } else if (rank == 3) {
      return <Medal>🥉</Medal>;
    } else {
      return <Rank>{rank}</Rank>;
    }
  }

  return (
    <Container {...props} teamColor={BRACELET_COLORS[props.team]}>
      <RankAndPlayer>
        {MedalRank(props.rank)}
        <Player>
          <h4>{props.playerName}</h4>
          <h3>Team {BRACELET_NAMES[props.team]}</h3>
        </Player>
      </RankAndPlayer>
      <Point>
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="11.7184" cy="11.7184" r="11.7184" fill="white" />
          <path
            d="M11.953 16.7964H9.1125V6.27907H11.8644C13.2359 6.27907 14.2531 6.55835 14.9161 7.11691C15.6972 7.77538 16.0877 8.69042 16.0877 9.86204C16.0877 11.1381 15.6722 12.0895 14.8412 12.7162C14.2735 13.1385 13.4584 13.3496 12.3958 13.3496H11.953V16.7964ZM11.953 10.986L12.0824 10.9928C12.4275 10.9928 12.7023 10.8883 12.9066 10.6794C13.111 10.466 13.2132 10.1754 13.2132 9.80754C13.2132 9.44425 13.1133 9.14908 12.9134 8.92202C12.7136 8.69042 12.4593 8.57462 12.1505 8.57462H11.953V10.986Z"
            fill="black"
          />
        </svg>
        <h4>{props.point.toLocaleString()}</h4>
      </Point>
    </Container>
  );
}

LeaderboardRankCard.defaultProps = {
  playerName: "Jonathan Filbert",
  team: "Valor",
  rank: 4,
  point: 9123,
  teamColor: "2EAF76",
};
